var CountryFormController = (function () {
    function CountryFormController() {
        this.countries = [];
        this.states = [];
    }
    CountryFormController.prototype.countrySelected = function (countryId) {
        var country = (this.countries || []).filter(function (c) { return c.id === countryId; })[0];
        var states = country !== undefined ? country.states : [];
        this.states = states;
    };
    return CountryFormController;
}());
export { CountryFormController };
